<template>
  <div class="info_notific">
    <n-popover placement="bottom" trigger="click" :theme-overrides="popverTheme" @update:show="handleUpdateShow">
      <template #trigger>
        <div class="contact_container">
          <svg-icon class="notice_icon" icon-name="lingdanSvg" icon-class="lingdanSvg"></svg-icon>

          <div v-if="noticeList.length > 0" class="notice_badge"></div>
        </div>
      </template>
      <div>
        <div v-if="noticeList.length > 0" class="notice_container">
          <div class="notice_head">
            <div class="head_name">Notice</div>
            <div class="head_event" @click.stop="onReadAllNotice">All Read</div>
          </div>
          <div class="notice_centent">
            <TransitionGroup name="list" tag="ul">
              <div
                v-for="item in noticeList"
                :key="item.id"
                class="notice_centent_item animate__backOutRight"
                @click="hrefRequestClick(item)"
              >
                <div>
                  <div class="close_item">
                    <n-icon size="12">
                      <CloseCircleOutline @click.stop="item.id, item.noticeChannel" />
                    </n-icon>
                  </div>
                  <div class="centent_item_head">
                    <span class="centent_item_head_name">{{ item.noticeTitle }}</span>
                    <span class="centent_item_head_time">{{ item.updateTime }}</span>
                  </div>
                  <div class="">
                    <n-ellipsis>
                      <template #tooltip>
                        <span>
                          {{ item.noticeContext }}
                        </span>
                      </template>
                      <span class="centent_item_des">
                        {{ item.noticeContext }}
                      </span>
                    </n-ellipsis>
                  </div>
                </div>
              </div>
            </TransitionGroup>
          </div>
        </div>
        <div v-else class="notice_container no_notice">
          <n-empty description="No Notice Now"> </n-empty>
        </div>
      </div>
    </n-popover>
  </div>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import { CloseCircleOutline } from '@vicons/ionicons5';

import { getNotice, readOneNotice, readAllNotice } from '@/api/request';

const popverTheme = {
  padding: 0,
  borderRadius: '6px',
};

const noticeList = ref([]);

const hrefRequestClick = (item: any) => {
  // return
  const { noticeJumpUrl, id, noticeChannel } = item;
  location.href = '/#' + noticeJumpUrl;
  closeNotice(id, noticeChannel);
};

const handleUpdateShow = () => {
  fecthGetNotice();
};

const closeNotice = async (id: number, channel: string) => {
  await readOneNotice({
    id: id,
    channel: channel,
  });
  fecthGetNotice();
};

const onReadAllNotice = async () => {
  await readAllNotice();
  fecthGetNotice();
};

onMounted(() => {
  fecthGetNotice();
});

const fecthGetNotice = () => {
  getNotice().then((res) => {
    noticeList.value = (res || []).filter((item: any) => item.readFlag === 0);
  });
};
</script>
<style lang="scss" scoped>
@import '@/styles/_global.scss';

.notice_container {
  width: 320px;
  padding: 0;
}
.notice_icon {
  font-size: 20px;
  cursor: pointer;
  &:hover {
    color: $color-primary;
  }
}

.contact_container {
  position: relative;
  font-size: 16px;
}

.head_name {
  font-size: 16px;
  font-weight: bold;
  color: #000;
}

.head_event {
  color: #572df3;
  font-size: 12px;
  cursor: pointer;
}

.notice_centent {
  max-height: 300px;
  overflow-y: scroll;
  // padding-right: 10px;

  ul {
    padding-inline-start: 0;
  }
}

.notice_footer {
  padding: 12px 0;
  text-align: center;
  color: #572df3;
  line-height: 1;
  font-size: 12px;

  span {
    cursor: pointer;
  }
}

.notice_centent_item {
  padding: 14px 16px;
  border-bottom: 1px solid #f2f2f2;
  cursor: pointer;
  position: relative;

  &:hover {
    background-color: #f5f6ff;

    .centent_item_head_name,
    .centent_item_head_time,
    .centent_item_des {
      color: #572df3;
    }

    .close_item {
      display: block;
    }
  }
}
.notice_badge {
  width: 10px;
  height: 10px;
  position: absolute;
  background-color: #d03050;
  border-radius: 50%;
  right: 0px;
  top: 0px;
}

.notice_head {
  padding: 16px;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f2f2f2;
  align-items: center;
  line-height: 1;
}

.close_item {
  color: #572df3;
  position: absolute;
  right: 4px;
  top: 0;
  line-height: 1;
  display: none;
}

.centent_item_head {
  color: #666666;
  font-size: 12px;
  padding-left: 16px;
  position: relative;
  line-height: 1;
  display: flex;
  justify-content: space-between;

  &::before {
    content: '';
    display: block;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #dc3d63;
    top: 2px;
    left: 0;
    position: absolute;
  }
}

.centent_item_head_time {
  min-width: 120px;
  text-align: right;
}

.centent_item_des {
  color: #262626;
  font-size: 12px;
  line-height: 1;
  margin-top: 12px;
}

.no_notice {
  padding: 20px 0;
}

.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
